import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import Cookies from 'js-cookie';
import Swal from "sweetalert2";

import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import styles from './style.module.css';
import { getFormattedTime } from "../../utilities/axios.utilities";
import ProgressBar from '../NH/components/ProgressBar';

interface TableItem {
  time: string;
  percent: number;
  typeGame: string;
  name: string;
  _id: string;
}

const Slot = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);
  const [tableList, setTableList] = useState<TableItem[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const { room } = useParams();
  const currentTime = getFormattedTime();
  const [isLoading, setIsLoading] = useState(false);

  // Function to remove accents and convert to lowercase
  const normalizeString = (str: string) => {
    return str
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  };

  // Filter tableList based on search term
  const filteredTableList = tableList.filter((item) => {
    if (!searchTerm) return true;
    const normalizedTitle = normalizeString(item.name);
    const normalizedSearch = normalizeString(searchTerm);
    return normalizedTitle.includes(normalizedSearch);
  });

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    if (!isLoading) {
      Swal.fire({
        title: "Đang tải dữ liệu trò chơi",
        html: "<p class='swal-loading-subtext'>Load Data.</p><div class='swal-loading-dots'><span class='swal-dot swal-dot-cyan'></span><span class='swal-dot swal-dot-orange'></span></div>",
        customClass: {
          popup: "swal-loading-modal",
        },
        allowOutsideClick: false,
        showConfirmButton: false,
      });
    }

    const fetchTableList = async () => {
      try {
        const token = Cookies.get("access_token");
        const response = await axios.get(
          `${process.env.REACT_APP_URL_API_CASINO}/NH/tableList?typeGame=${room}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
        setTableList(response.data);
        if (response.data) {
          setTimeout(() => {
            setIsLoading(true);
            Swal.close();
          }, 2000);
        }
      } catch (error) {
        console.error('Error fetching table list:', error);
      }
    };

    fetchTableList();
    window.scrollTo(0, 0);
  }, [room]);

  localStorage.setItem("NH_PAGE", String(room));

  return (
    <div>
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      {isLoading && (
        <div className={`container-fluid lobby-bg position-relative mx-auto mb-5 max-w-screen-xl`}>
          <div className="container mx-auto">
            <div className="flex flex-wrap my-7">
              <div className="w-1/2 md:w-2/3">
                <input
                  type="search"
                  value={searchTerm}
                  onChange={handleSearch}
                  className={'w-full max-w-full md:max-w-[25%] h-12 px-4 text-white bg-opacity-20 bg-white border border-white rounded-[20px] transition duration-300 ease-in-out placeholder-white focus:outline-none focus:border-white focus:shadow-[0_0_5px_2px_rgba(255,255,255,0.6)]'}
                  placeholder="Tìm kiếm..."
                />
              </div>
              <div className="w-1/2 md:w-1/3 flex justify-center items-center">
                <a href="/NH" className="text-white no-underline">
                  <div className="box-goto-lobby">
                    Quay lại
                  </div>
                </a>
              </div>
            </div>
            <label className={"font-semibold text-white text-center block " + styles.loadTime}>
              {room} | Load Time: {currentTime}
            </label>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {filteredTableList.map((item, index) => (
                <div
                  key={index}
                  className="transition-all duration-300 ease-in-out transform hover:scale-105"
                  style={{
                    opacity: 1,
                    animation: "fadeIn 0.3s ease-in-out"
                  }}
                >
                  <ProgressBar
                    percentage={item.percent}
                    title={item.name}
                    imageUrl={`/assets/NH/${room}/${room}_${(index + 1).toString().padStart(2, '0')}.png`}
                    id={item._id}
                  />
                </div>
              ))}
            </div>
            <div style={{ height: 200 }}></div>
          </div>
        </div>
      )}
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default Slot;
